import {
  Swiper, EffectFade, Navigation, Lazy,
} from 'swiper';
import HideOffscreenSlides from '../../components/modules/swiper-hide-offscreen';

window.addEventListener('load', () => {
  // eslint-disable-next-line no-new
  new Swiper('.post-image-and-text__swiper', {
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },

    navigation: {
      prevEl: '.post-image-and-text__button-prev',
      nextEl: '.post-image-and-text__button-next',
    },
    modules: [EffectFade, Navigation, Lazy, HideOffscreenSlides],
    lazy: {
      loadPrevNext: true,
      preloaderClass: 'c-slide-preloader',
      preloadImages: false,
    },
  });
});
